(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hero-video-slideshow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hero-video-slideshow')) {
    class HeroVideoSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hvs__slide'));
        this.dots = Array.from(this.querySelectorAll('.hvs__dot'));
        this.current = 0;
        this.timer = null;
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.speed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
        this.waitForVideo = this.dataset.waitForVideo === 'true';
        this.mobileQuery = window.matchMedia('(max-width: 749px)');

        this.querySelector('.hvs__arrow--prev')?.addEventListener('click', () => this.go(this.current - 1));
        this.querySelector('.hvs__arrow--next')?.addEventListener('click', () => this.go(this.current + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.index))));

        this.querySelectorAll('video').forEach((video) => {
          video.addEventListener('ended', () => this.onVideoEnded(video));
        });

        this.onBreakpointChange = () => this.show(this.current);
        this.mobileQuery.addEventListener('change', this.onBreakpointChange);

        this.setupSwipe();
        this.show(0);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.mobileQuery?.removeEventListener('change', this.onBreakpointChange);
      }

      /** The video shown at the current screen size in a slide, if any. */
      visibleVideo(slide) {
        const isMobile = this.mobileQuery.matches;
        return Array.from(slide.querySelectorAll('video')).find((video) => {
          if (video.classList.contains('hvs__media--mobile')) return isMobile;
          if (video.classList.contains('hvs__media--desktop')) return !isMobile;
          return true;
        });
      }

      go(index) {
        const count = this.slides.length;
        this.show(((index % count) + count) % count);
      }

      show(index) {
        clearTimeout(this.timer);
        this.current = index;

        this.slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('a').forEach((link) => (link.tabIndex = active ? 0 : -1));
          slide.querySelectorAll('video').forEach((video) => video.pause());
        });

        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));

        const video = this.visibleVideo(this.slides[index]);
        const advanceOnEnd = this.autoplay && this.waitForVideo && video;

        if (video) {
          // Loop the video unless the slideshow moves on when it finishes.
          video.loop = !advanceOnEnd;
          video.currentTime = 0;
          if (video.preload === 'none') video.preload = 'auto';
          video.play().catch(() => {});
        }

        if (this.autoplay && !advanceOnEnd) {
          this.timer = setTimeout(() => this.go(this.current + 1), this.speed);
        }

        this.preloadNext();
      }

      onVideoEnded(video) {
        if (video === this.visibleVideo(this.slides[this.current]) && !video.loop) {
          this.go(this.current + 1);
        }
      }

      preloadNext() {
        const next = this.slides[(this.current + 1) % this.slides.length];
        const video = next && this.visibleVideo(next);
        if (video && video.preload === 'none') video.preload = 'metadata';
      }

      setupSwipe() {
        if (this.slides.length < 2) return;
        let startX = 0;
        let startY = 0;

        this.addEventListener('touchstart', (event) => {
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        }, { passive: true });

        this.addEventListener('touchend', (event) => {
          const dx = event.changedTouches[0].clientX - startX;
          const dy = event.changedTouches[0].clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.go(this.current + (dx < 0 ? 1 : -1));
          }
        }, { passive: true });
      }
    }

    customElements.define('hero-video-slideshow', HeroVideoSlideshow);
  }
  } catch(e) { console.error(e); }
})();

})();
